export const SET_ORIENTATION = "SET_ORIENTATION" ;
export const SAVE_ADDRESS_PROJECT = "SAVE_ADDRESS_PROJECT";
export const SAVE_PROJECT_NAME = "SAVE_PROJECT_NAME";
export const SAVE_PROJECT_STATE = "SAVE_PROJECT_STATE";
export const SAVE_MODULES_AND_POWER = "SAVE_MODULES_ANS_POWER";
export const REORIENTE_RECTANGLE = "REORIENTE_RECTANGLE";
export const GET_PRODUCTIBLE = "GET_PRODUCTIBLE";
export const GET_GHI = "GET_GHI";
export const SAVE_ID_PROJECT = "SAVE_ID_PROJECT";